export default function ({ $axios, app, store }) {
  $axios.onRequest((config) => {
    const apolloToken = app.$cookies.get('apollo-token')

    if (apolloToken && !config.headers['OTA-External']) {
      config.headers.Authorization = `Bearer ${apolloToken}`
    }

    if (store.state && store.state.app) {
      config.headers['Accept-Language'] = `${store.state.app.locale}_${store.state.app.country.toUpperCase()}`
    }

    config.metadata = config.metadata || {}
    config.metadata.requestId = Math.random().toString(36).substring(2, 15) + Math.random().toString(36).substring(2, 15)
  })

  $axios.onError((err) => {
    if (
      err.response.headers['content-type'].includes('text/html') &&
      err.response.status === 405 &&
      err.response.data &&
      err.response.data.toLowerCase().includes('captcha') &&
      window !== undefined
    ) {
      window.location.reload()
    }
  })
}
